import { render, staticRenderFns } from "./regions.vue?vue&type=template&id=9c3cd904"
import script from "./regions.vue?vue&type=script&lang=js"
export * from "./regions.vue?vue&type=script&lang=js"
import style0 from "./regions.vue?vue&type=style&index=0&id=9c3cd904&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports